import React from "react";
import Card, { CardContent } from "@/components/ui/Card.jsx";
import Button from "@/components/ui/Button.jsx";
import ListItem56px from "@/sot/primitives/ListItem56px.jsx";

/** Booking actions are server-shaped data rendered with existing AfriMed primitives. */
export default function FolaBookingAction({ item, onAction }) {
  if (item?.type === "fola-booking-services") {
    return <section className="w-full max-w-[560px]" aria-label="Available booking services">
      <p className="px-4 pb-2 pt-1 text-body-medium text-on-surface">{item.intro}</p>
      <div className="bg-[rgb(var(--clr-surface))]">
        {(item.services || []).map((service) => <ListItem56px key={service.id} variant="bare" title={service.name} support={`${service.durationMinutes} min · ${service.currency} ${Number(service.price || 0).toLocaleString("en-ZA")}`} showChevron onClick={() => onAction?.({ id: "select-booking-service", service, action: item.action })} />)}
      </div>
    </section>;
  }
  if (item?.type === "fola-booking-options") {
    return <div className="w-full max-w-[560px] space-y-2">
      <p className="text-body-medium text-on-surface">{item.intro}</p>
      <div className="bg-[rgb(var(--clr-surface))]">
        {item.slots.map((slot) => <ListItem56px key={slot} variant="bare" title={slot} support={item.dateLabel} showChevron onClick={() => onAction?.({ id: "select-booking-slot", slot, action: item.action })} />)}
      </div>
    </div>;
  }
  if (item?.type === "fola-booking-decision") {
    return <section className="w-full max-w-[560px]" aria-label={item.intro || "Booking decision"}>
      <p className="px-4 pb-2 pt-1 text-body-medium text-on-surface">{item.intro}</p>
      <div className="bg-[rgb(var(--clr-surface))]">
        {(item.options || []).map((option) => <ListItem56px key={option.value} variant="bare" title={option.label} support={option.support} showChevron onClick={() => onAction?.({ id: "select-booking-decision", decision: item.decision, value: option.value })} />)}
      </div>
    </section>;
  }
  if (item?.type === "fola-booking-confirmation") {
    return <Card className="w-full max-w-[560px]"><CardContent className="space-y-4 p-4">
      <p className="text-body-medium text-on-surface">{item.summary}</p>
      <div className="flex flex-wrap gap-2"><Button onClick={() => onAction?.({ id: "confirm-booking-intent", intentId: item.intentId })}>Confirm booking and continue to checkout</Button></div>
    </CardContent></Card>;
  }
  return null;
}
